module.exports = __webpack_public_path__ + "static/media/after-Introduksjon-sprakforstael.34ca0ad7.mp3";